<template>
  <div>
    <v-radio-group v-model="editedItem.is_video" row>
      <v-radio :label="$tc('articles.radio_text', 1)" :value="true"></v-radio>
      <v-radio :label="$tc('articles.radio_text', 2)" :value="false"></v-radio>
    </v-radio-group>
    <!------------------------------------------------->
    <!-- FORMS ---------------------------------------->
    <!------------------------------------------------->
    <v-form
      v-if="editedItem.is_video"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <h1>{{ $tc("articles.title", 1) }}</h1>
      <v-text-field
        v-model="editedItem.title"
        :rules="titleRules"
        :label="$tc('articles.form.title', 1)"
        required
      ></v-text-field>

      <v-text-field
        v-model="editedItem.link"
        :rules="linkRules"
        :label="$tc('articles.form.link', 1)"
        required
      ></v-text-field>

      <v-text-field
        v-model="editedItem.description"
        :rules="descriptionRules"
        :label="$tc('articles.form.description', 1)"
        required
      ></v-text-field>

      <v-row>
        <v-col cols="12" md="3">
          <v-autocomplete
            v-model="editedItem.section"
            :items="itemsSection"
            item-text="text"
            item-value="value"
            chips
            :rules="sectionRules"
            :label="$tc('articles.form.select', 1)"
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            v-model="editedItem.language_code"
            :items="languages"
            item-text="name"
            item-value="code"
            chips
            :rules="languageRules"
            :label="$t('articles.form.language')"
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="1">
          <v-text-field
            v-model="editedItem.order"
            :rules="orderRules"
            :label="$t('articles.form.order')"
            required
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-btn
        :disabled="!valid"
        color="blue darken-4 white--text"
        class="mr-4"
        @click.prevent="save"
      >
        {{ $t("articles.buttons.confirm") }}
      </v-btn>

      <v-btn color="grey" class="mr-4" @click="reset" v-if="editModeDisabled">
        {{ $t("articles.buttons.reset") }}
      </v-btn>

      <v-btn color="grey" class="mr-4" @click="close" v-if="!editModeDisabled">
        {{ $t("articles.buttons.cancel") }}
      </v-btn>
    </v-form>
    <v-form v-else ref="form" v-model="valid" lazy-validation>
      <h1>{{ $tc("articles.title", 2) }}</h1>
      <v-text-field
        v-model="editedItem.title"
        :rules="titleRules"
        :label="$tc('articles.form.title', 2)"
        required
      ></v-text-field>

      <v-text-field
        v-model="editedItem.link"
        :rules="linkRules"
        :label="$tc('articles.form.link', 2)"
        required
      ></v-text-field>
      <v-textarea
        outlined
        name="input-7-4"
        :label="$tc('articles.form.description', 2)"
        v-model="editedItem.description"
      ></v-textarea>
      <v-row>
        <v-col cols="12" md="3">
          <v-autocomplete
            v-model="editedItem.section"
            :items="itemsSection"
            item-text="text"
            item-value="value"
            chips
            :rules="sectionRules"
            :label="$tc('articles.form.select', 2)"
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            v-model="editedItem.language_code"
            :items="languages"
            item-text="name"
            item-value="code"
            chips
            :rules="languageRules"
            :label="$t('articles.form.language')"
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="1">
          <v-text-field
            v-model="editedItem.order"
            :rules="orderRules"
            :label="$t('articles.form.order')"
            required
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-btn
        :disabled="!valid"
        color="blue darken-4 white--text"
        class="mr-4"
        @click.prevent="save"
      >
        {{ $t("articles.buttons.confirm") }}
      </v-btn>

      <v-btn color="grey" class="mr-4" @click="reset" v-if="editModeDisabled">
        {{ $t("articles.buttons.reset") }}
      </v-btn>

      <v-btn color="grey" class="mr-4" @click="close" v-if="!editModeDisabled">
        {{ $t("articles.buttons.cancel") }}
      </v-btn>
    </v-form>

    <v-divider class="mx-4" inset vertical></v-divider>

    <!------------------------------------------------->
    <!-- TABLE ---------------------------------------->
    <!------------------------------------------------->
    <v-layout wrap>
      <v-flex xs12 pt-4>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  :label="$t('general.search')"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-autocomplete
                  :items="itemsSection"
                  item-text="text"
                  item-value="value"
                  v-model="filtered"
                  :label="$t('articles.table.filter_by_section')"
                  outlined
                  hide-details
                  clearable
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-data-table
            :headers="headers"
            :items="linksToInfoFiltered"
            :search="search"
            sort-by="section"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>{{
                  $t("articles.table.header")
                }}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialogDelete" max-width="600px">
                  <v-card>
                    <v-card-title class="text-h5">{{
                      $t("articles.dialog.delete")
                    }}</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">{{
                        $t("articles.buttons.cancel")
                      }}</v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="deleteItemConfirm"
                        >OK</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDisable" max-width="650px">
                  <v-card>
                    <v-card-title v-if="editedItem.disabled" class="text-h5">{{$t("articles.dialog.enable")}}</v-card-title>
                    <v-card-title v-else class="text-h5">{{$t("articles.dialog.disable")}}</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDisable">{{
                        $t("articles.buttons.cancel")
                      }}</v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="disableItemConfirm"
                        >OK</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu
                left
                offset-y
                nudge-bottom="10"
                transition="slide-y-transition"
                min-width="180px"
              >
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="editItem(item)">
                    {{ $t("articles.buttons.edit") }}
                  </v-list-item>
                  <v-list-item @click="deleteItem(item)">
                    {{ $t("articles.buttons.delete") }}
                  </v-list-item>
                  <v-list-item v-if="item.disabled" @click="disableItem(item)">
                    {{ $t("articles.buttons.enable") }}
                  </v-list-item>
                  <v-list-item v-else @click="disableItem(item)">
                    {{ $t("articles.buttons.disable") }}
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:item.description="{ item }">
              <tr>
                <td class="truncateDescription">{{ item.description }}</td>
              </tr>
            </template>
            <template v-slot:item.link="{ item }">
              <tr>
                <td class="truncateLink">{{ item.link }}</td>
              </tr>
            </template>
            <template v-slot:item.order="{ item }">
              <tr class="d-flex justify-center">
                <td >{{ item.order }}</td>
              </tr>
            </template>
            <template v-slot:item.language_code="{ item }">
              <tr class="d-flex justify-center">
                <td >{{ item.language_code }}</td>
              </tr>
            </template>
            <template v-slot:item.disabled="{ item }">
              <tr class="d-flex justify-center" v-if="item.disabled">
                <v-icon style="color:red;">close</v-icon>
              </tr>
              <tr class="d-flex justify-center" v-else>
                <v-icon style="color:green;">check</v-icon>
              </tr>
            </template>
          </v-data-table>
        </v-card> </v-flex
    ></v-layout>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

export default {
  name: "Articles",
  layout: "Dashboard",

  data() {
    return {
      search: null,

      filtered: null,
      editModeDisabled: true, //controla el boton de editar
      valid: true, //Habilita el boton de guardar cuando el formulario es valido
      titleRules: [
        (v) => !!v || "Title is required",
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      linkRules: [
        (v) => !!v || "Link is required",
        (v) =>
          /^https?:\/\/[\w\-]+(\.[\w\-]+)+[/#?]?.*$/.test(v) ||
          "Link must be valid",
      ],
      descriptionRules: [
        (v) => !!v || "Description is required",
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      orderRules: [
        (v) => !!v || "order is required",
        (v) => /^\d+$/.test(v) || "Order must be a number",
      ],
      sectionRules: [
        (v) => !!v || "Section is required",
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      languageRules: [
        (v) => !!v || "language is required",
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],

      itemsSection: [
        { value: "/", text: this.$t("articles.sections.home") },
        { value: "/transactions", text: this.$t("articles.sections.transactions") },
        { value: "/subscriptions/home", text: this.$t("articles.sections.subscriptions_home") },
        { value: "/subscriptions/list", text: this.$t("articles.sections.subscriptions_list") },
        { value: "/subscriptions/pendings", text: this.$t("articles.sections.subscriptions_pendings") },
        { value: "/members", text: this.$t("articles.sections.members") },
        { value: "/campaigns", text: this.$t("articles.sections.campaigns") },
        { value: "/giving-form", text: this.$t("articles.sections.giving-forms") },
        { value: "/magic-button", text: this.$t("articles.sections.magic-button") },
        { value: "/lead-form", text: this.$t("articles.sections.lead-forms") },
        { value: "/docs-form", text: this.$t("articles.sections.docs-forms") },
        { value: "/segments", text: this.$t("articles.sections.segments") },
        { value: "/recurring-debit", text: this.$t("articles.sections.recurring-debits") },
        { value: "/imports", text: this.$t("articles.sections.imports") },
        { value: "/downloads", text: this.$t("articles.sections.downloads") },
        { value: "/landings/pages", text: this.$t("articles.sections.landings_pages") },
        { value: "/landings/templates", text: this.$t("articles.sections.landings_templates") },
        { value: "/landings/domains", text: this.$t("articles.sections.landings_domains") },
        { value: "/certificates/certificates", text: this.$t("articles.sections.certificates") },
        { value: "/certificates/events", text: this.$t("articles.sections.certificates_events") },
        { value: "/certificates/templates", text: this.$t("articles.sections.certificates_templates") },
        { value: "/certificates/emails", text: this.$t("articles.sections.certificates_emails") },
        { value: "/crowdfunding/petitions", text: this.$t("articles.sections.crowdfunding_petitions") },
        { value: "/crowdfunding/petitions-form", text: this.$t("articles.sections.crowdfunding_petitions-form") },
        { value: "/crowdfunding/donations-form", text: this.$t("articles.sections.crowdfunding_donations-form") },
        { value: "/crowdfunding/creators", text: this.$t("articles.sections.crowdfunding_creators") },
        { value: "/crowdfunding/projects", text: this.$t("articles.sections.crowdfunding_projects") },
        { value: "/crowdfunding/api", text: this.$t("articles.sections.crowdfunding_api") },
        { value: "/petitions/summary", text: this.$t("articles.sections.petitions_summary") },
        { value: "/petitions/requests", text: this.$t("articles.sections.petitions_requests") },
        { value: "/petitions/approved", text: this.$t("articles.sections.petitions_approved") },
        { value: "/petitions/signature-forms", text: this.$t("articles.sections.petitions_signature-forms") },
        { value: "/petitions/creators", text: this.$t("articles.sections.petitions_creators") },
        { value: "/petitions/emails", text: this.$t("articles.sections.petitions_emails") },
        { value: "/petitions/templates", text: this.$t("articles.sections.petitions_templates") },
        { value: "/petitions/settings", text: this.$t("articles.sections.petitions_settings") },
        { value: "/petitions/api", text: this.$t("articles.sections.petitions_api") },
        { value: "/lead-advanced", text: this.$t("articles.sections.lead-advanced") },
        { value: "/secure-data-storage", text: this.$t("articles.sections.secure-data-storage") },
        { value: "/automation", text: this.$t("articles.sections.automation") },
        { value: "/automation/newsletter", text: this.$t("articles.sections.automation_newsletter") },
        { value: "/automation/sequences", text: this.$t("articles.sections.automation_sequences") },
        { value: "/automation/templates", text: this.$t("articles.sections.automation_templates") },
        { value: "/automation/sequences-templates", text: this.$t("articles.sections.automation_sequences-templates") },
        { value: "/autoresponders/triggers", text: this.$t("articles.sections.autoresponders_triggers") },
        { value: "/comunications/attachments", text: this.$t("articles.sections.comunications_attachments") },
      ],
      // TABLA--------------------------------------------
      dialogDelete: false,
      dialogDisable:false,
      headers: [
        {
          text: this.$t("articles.table.link"),
          align: "start",
          sortable: false,
          value: "link",
        },
        { text: this.$t("articles.table.title"), value: "title" },
        { text: this.$t("articles.table.section"), value: "section" },
        { text: this.$t("articles.table.is_video"), value: "is_video" },
        { text: this.$t("articles.table.description"), value: "description" },
        {
          text: this.$t("articles.table.language"),
          value: "language_code",
          sortable: true,
        },
        {
          text: this.$t("articles.table.order"),
          value: "order",
          sortable: false,
        },
        {
          text: this.$t("articles.table.disabled"),
          value: "disabled",
          sortable: false,
        },
        {
          text: this.$t("articles.table.actions"),
          value: "actions",
          sortable: false,
        },
      ],
      editedIndex: -1,
      editedItem: {
        id: 0,
        link: "",
        title: "",
        section: "",
        is_video: true,
        description: "",
        language_code: "",
        order: 1,
        disabled: false,
      },
      defaultItem: {
        id: 0,
        link: "",
        title: "",
        section: "",
        is_video: true,
        description: "",
        language_code: "",
        order: 1,
        disabled: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      linksToInfoFiltered: "onboarding/articlesFiltered",
    }),
    ...mapState({
      languages: ({ auth: { locales } }) => locales,
    }),
  },

  watch: {
    dialogDisable(val) {
      val || this.closeDisable();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    filtered(val) {
      this.filterBySection(val);
    },
  },

  async created() {
    this.readArticles();
  },

  methods: {
    ...mapMutations({
      filterBySection: "onboarding/filterBySection",
    }),
    ...mapActions({
      getArticles: "onboarding/getArticles",
      postArticle: "onboarding/postArticle",
      putArticle: "onboarding/putArticle",
      deleteArticle: "onboarding/deleteArticle",
    }),
    async readArticles() {
      await this.getArticles();
    },
    async createArticle() {
      await this.postArticle(this.editedItem);
    },
    async updateArticle() {
      await this.putArticle(this.editedItem);
    },
    async destroyArticle() {
      await this.deleteArticle(this.editedItem);
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },

    formatYouTubeVideo(link) {
      if (this.editedItem.is_video) {
        return link.replace("watch?v=", "embed/");
      } else {
        return link;
      }
    },

    editItem(item) {
      this.editedIndex = this.linksToInfoFiltered.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editModeDisabled = false;
    },

    deleteItem(item) {
      this.editedIndex = this.linksToInfoFiltered.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.$refs.form.resetValidation();
      this.destroyArticle();
      this.closeDelete();
    },

    disableItem(item) {
      this.editedIndex = this.linksToInfoFiltered.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDisable = true;
    },
    disableItemConfirm() {
      this.editedItem.disabled = !this.editedItem.disabled;
      this.$refs.form.resetValidation();
      this.updateArticle();
      this.closeDisable();
    },

    close() {
      this.editModeDisabled = true;
      this.$refs.form.resetValidation();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$refs.form.resetValidation();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDisable() {
      this.dialogDisable = false;
      this.$refs.form.resetValidation();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.editModeDisabled = true;
          this.editedItem.link = this.formatYouTubeVideo(this.editedItem.link);
          this.updateArticle();
        } else {
          this.editedItem.link = this.formatYouTubeVideo(this.editedItem.link);
          this.createArticle();
        }
        this.readArticles();
        this.$refs.form.resetValidation();
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.truncateDescription {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.truncateLink {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>